import React from 'react'
import {Box, Button, Paper, Typography} from '@mui/material'
import {Link} from 'react-router-dom'
export const StickyBottom = () => {
  /*
  <Button component={Link} reloadDocument to={"/VR"}
        style={{display:"inline", color:"white", position:"fixed", bottom: 0, width:"100%", backgroundColor:"#e8ad59",
        borderRadius:"0px"}}>
          <Typography variant="h4" fontFamily={"Copperplate"}>
          BOOK NOW
          </Typography>
          </Button>
  */
  return (
      <>
        <Box display={{xs:"flex", sm: "none"}} textAlign="center">
        <Paper style={{ color:"white", position:"fixed", bottom: 0, width:"100%", backgroundColor:"black",
        borderRadius:"0px", opacity:".8"}}>
          <Button component={Link} reloadDocument to={"/VR"} style={{width:"100%"}}>
          <Typography variant="h4" fontFamily={"Copperplate"}>
          BOOK NOW
          </Typography>
          </Button>
          </Paper>
        </Box>
      </>
  )
}
